// automatically generated by the FlatBuffers compiler, do not modify

/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */

/**
 * Adapter transport type.
 */
export enum AdapterType {
  REST = 0,
  GRAPHQL = 1,
  GRPC = 2,
  SOAP = 3,
  WEBSOCKET = 4,
  TCP = 5,
}
